<template>
  <v-layout row class="alertRow selectable" @click="rowClicked">
    <v-flex sm1 xs2 class="align-self-center">
      <v-icon medium>mdi-alarm</v-icon>
    </v-flex>
    <v-flex sm3 xs4 pr-2 class="align-self-center">
      <div class="student-name prevent-overflow">
        <span v-if="nameBreakType === undefined || nameBreakType === 'both'">
            {{alert.student.firstName | nameBreak(nameBreakSize)}} {{alert.student.lastName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else-if="nameBreakType === 'combined'">
            {{combineStudentName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else>
            {{alert.student.firstName}} {{alert.student.lastName}}
          </span>
      </div>
      <div class="caption prevent-overflow">{{getDisplayId | nameBreak}}</div>
    </v-flex>
    <v-flex sm2 xs3 class="align-self-center">
      <div class="prevent-overflow">{{alert.alert.name}}</div>
      <div class="hidden-sm-and-up">
        {{alert.alertDate | date}}
      </div>
    </v-flex>
    <v-flex sm3 class="align-self-center hidden-xs-only">
      {{alert.alertDate | date}}
    </v-flex>
    <v-flex sm3 xs3>
    </v-flex>
  </v-layout>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import NameBreak from '../../mixins/NameBreak'
  import { mapGetters } from 'vuex'
  import { GET_STUDENT_TRUNCATION_SIZE, GET_STUDENT_TRUNCATION_TYPE } from '../../store/getter-types'

  export default {
    name: 'tutor-alert',
    props: ['alert'],
    mixins: [DateFormat, NameBreak],
    computed: {
      ...mapGetters({
        nameBreakSize: GET_STUDENT_TRUNCATION_SIZE,
        nameBreakType: GET_STUDENT_TRUNCATION_TYPE
      }),
      combineStudentName () {
        return this.alert.student.firstName + ' ' + this.alert.student.lastName
      },
      getDisplayId () {
        return this.alert.student.displayId ? this.alert.student.displayId : this.alert.student.studentIdentifier
      }
    },
    methods: {
      rowClicked () {
        this.$emit('row-clicked', this.alert)
      }
    }
  }
</script>

<style scoped>
  .align-self-center {
    align-self: center;
  }

  .selectable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/TutorAlert.vue